@let p = profile();
@let bioText = (p?.bio | translateData) || '';
@let addressText = (p?.address | translateData) || '';
<article class="developer-profile-card">
  <div class="developer-profile-card__media">
    <img
      class="developer-profile-card__logo"
      [ngSrc]="(p?.logo ?? '') | imageSource: true : 'md' : logoPlaceholder"
      [width]="120"
      [height]="120"
      [alt]="p?.title | translateData" />
  </div>
  <div class="developer-profile-card__body">
    <div class="developer-profile-card__heading">
      <div class="developer-profile-card__heading-main">
        @if (showFirstName()) {
          <p class="developer-profile-card__first-name">
            {{ firstName() }}
          </p>
        }
        @if ((p?.title | translateData); as profileTitle) {
          @if (profileTitle && profileTitle !== '-') {
            <h3 class="developer-profile-card__title">
              {{ profileTitle }}
            </h3>
          }
        }
      </div>
      <span class="developer-profile-card__type">{{ typeTranslationKey() | translate }}</span>
    </div>
    @if (p?.exact_role) {
      <p class="developer-profile-card__role">{{ p.exact_role }}</p>
    }
    @if (showBio(bioText)) {
      <p
        class="developer-profile-card__bio"
        [class.people-profile-card-locked]="isBioLocked(bioText)">
        @if (isBioLocked(bioText)) {
          {{ bio(bioText) }}
        } @else {
          {{ bioText.length > 140 ? bioText.slice(0, 140) + '…' : bioText }}
        }
      </p>
    }
    <div class="developer-profile-card__meta">
      @if (showRegion()) {
        <span
          class="developer-profile-card__meta-item"
          [class.people-profile-card-locked]="isRegionLocked()">
          📍 {{ region() }}
        </span>
      }
      @if (showAddress(addressText)) {
        <span
          class="developer-profile-card__meta-item developer-profile-card__meta-address"
          [class.people-profile-card-locked]="isAddressLocked(addressText)">
          @if (isAddressLocked(addressText)) {
            {{ address(addressText) }}
          } @else {
            {{ addressText.length > 50 ? addressText.slice(0, 50) + '…' : addressText }}
          }
        </span>
      }
      @if (showWebsite(p?.website ?? '')) {
        @if (isWebsiteLocked(p?.website ?? '')) {
          <span
            class="developer-profile-card__meta-link people-profile-card-locked">
            🌐 {{ website(p?.website ?? '') }}
          </span>
        } @else if (p?.website) {
          <a
            [href]="p.website"
            target="_blank"
            rel="noopener"
            class="developer-profile-card__meta-link">
            🌐 {{ 'global.website' | translate }}
          </a>
        }
      }
    </div>
    @if (showContact()) {
      <div class="developer-profile-card__contact">
        @if (email(); as contactEmail) {
          @if (isEmailLocked()) {
            <span class="developer-profile-card__contact-link people-profile-card-locked">
              {{ contactEmail }}
            </span>
          } @else {
            <a
              [href]="'mailto:' + contactEmail"
              class="developer-profile-card__contact-link">
              {{ contactEmail }}
            </a>
          }
        }
        @if (phone(); as contactPhone) {
          <span
            class="developer-profile-card__contact-phone"
            [class.people-profile-card-locked]="isPhoneLocked()">
            {{ contactPhone }}
          </span>
        }
      </div>
    }
    @if ((p?.categories?.length ?? 0) > 0) {
      <div class="developer-profile-card__tags">
        @for (cat of (p?.categories ?? []).slice(0, 3); track cat._id) {
          <span class="developer-profile-card__tag">{{ cat?.title | translateData }}</span>
        }
      </div>
    }
    <div class="developer-profile-card__badges">
      @if (p?.bim_ready) {
        <span class="developer-profile-card__badge">BIM</span>
      }
      @if (p?.product_certificates_provided) {
        <span class="developer-profile-card__badge">{{ 'industries.certificates' | translate }}</span>
      }
    </div>
  </div>
</article>
